import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const gqlQuery = gql`
  query WhereToGoEDD {
    whereToGo {
      __typename
      ... on GoToEddRequest {
        id
        questions {
          id
          text
          options {
            id
            text
          }
        }
        tours {
          type
        }
      }
      ... on Error {
        ...error
      }
      ... on GoToError {
        ...error
      }
    }
  }
  ${error}
`;

export default gqlQuery;
